import React from "react";

const Data = () => {
  return (
    <main
      className="mx-auto max-w-[1600px] flex-1 px-4 py-10 sm:px-6 lg:px-8"
      data-testid="data-page"
    >
      <h1
        className="text-2xl font-semibold text-[#272c36]"
        data-testid="data-page-heading"
      >
        Data
      </h1>
      <p
        className="mt-4 text-base text-[#575757]"
        data-testid="data-page-description"
      >
        This section is in development.
      </p>
    </main>
  );
};

export default Data;
